import { render } from "./PayrollWidget.vue?vue&type=template&id=d81401ba&scoped=true"
import script from "./PayrollWidget.vue?vue&type=script&lang=js"
export * from "./PayrollWidget.vue?vue&type=script&lang=js"

import "./employee-attendance-widget.scss?vue&type=style&index=0&id=d81401ba&lang=scss&scoped=true"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81401ba"]])

export default __exports__